import React, { useEffect, useState } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { Alert, CircularProgress } from "@mui/material";
import { CheckoutForm } from "./CheckoutForm.tsx";
import { publishableKey } from "./config.js";

export const PaymentComponent = ({ amount, currency, onSuccess, selectedPlan, promoId }) => {
  const [stripePromise, setStripePromise] = useState<any>(null);
  const [stripeLoadError, setStripeLoadError] = useState(false);
  const [stripeLoading, setStripeLoading] = useState(true);

  useEffect(() => {
    if (!stripePromise && !stripeLoadError) {
      const promise = loadStripe(publishableKey, { developerTools: { assistant: { enabled: false } } });
      promise
        .then(() => setStripeLoading(false))
        .catch((err) => {
          console.error("[PaymentComponent] Failed to load Stripe.js:", err);
          setStripeLoadError(true);
          setStripeLoading(false);
        });
      setStripePromise(promise);
    }
  }, []);

  if (stripeLoadError) {
    return (
      <Alert severity="error">
        Unable to load the payment system. Please disable any ad blockers and
        refresh the page.
      </Alert>
    );
  }

  if (stripeLoading || !stripePromise) {
    return <CircularProgress size={24} sx={{ display: 'block', margin: '20px auto' }} />;
  }

  // Deferred Elements (#4334): nothing exists on Stripe until the card is submitted.
  return (
    <Elements stripe={stripePromise} options={{ mode: "subscription", amount, currency, paymentMethodTypes: ["card"] }}>
      <CheckoutForm onSuccess={onSuccess} selectedPlan={selectedPlan} promoId={promoId} amount={amount} currency={currency} />
    </Elements>
  );
}
